import { BookOpen, Link2, Package, Settings, TrendingUp, type LucideIcon } from 'lucide-react';
import { Button } from '@/components/ui/button';
import type { BlogCategory } from '@/content/blog-types';
import { cn } from '@/lib/utils';

export interface BlogTopic {
  key: 'all' | BlogCategory;
  label: string;
}

const BLOG_TOPIC_ICONS: Record<BlogCategory, LucideIcon> = {
  automation: Settings,
  sales: TrendingUp,
  integration: Link2,
  product: Package,
  guide: BookOpen,
};

interface BlogTopicFilterButtonProps {
  topic: BlogTopic;
  active: boolean;
  onSelect: (key: BlogTopic['key']) => void;
  className?: string;
}

export function BlogTopicFilterButton({
  topic,
  active,
  onSelect,
  className,
}: BlogTopicFilterButtonProps) {
  const Icon = topic.key === 'all' ? null : BLOG_TOPIC_ICONS[topic.key];

  return (
    <Button
      type="button"
      variant={active ? 'default' : 'outline'}
      onClick={() => onSelect(topic.key)}
      aria-pressed={active}
      className={cn(className, !active && 'bg-card border-border/60')}
    >
      {Icon ? (
        <Icon
          className={cn('size-4', active ? 'text-primary-foreground' : 'text-brand-gold')}
          aria-hidden
        />
      ) : null}
      {topic.label}
    </Button>
  );
}
